export function canTeacherEditQuestion(row, me) {
  if (!me || me.id == null) return false
  const role = row && row.createdByRole
  if (!role || role === 'ADMIN') return false
  if (role === 'TEACHER') {
    return row.createdBy != null && Number(row.createdBy) === Number(me.id)
  }
  return false
}

export function canTeacherEditHandout(item, me) {
  if (!me || me.id == null) return false
  const role = item && item.createdByRole
  if (!role || role === 'ADMIN') return false
  if (role === 'TEACHER') {
    return item.createdBy != null && Number(item.createdBy) === Number(me.id)
  }
  return false
}

export function isTeacherOwnHandout(item, me) {
  return canTeacherEditHandout(item, me)
}

export function isTeacherOwnPaper(row, me) {
  return !!(me && row && row.createdBy && Number(row.createdBy) === Number(me.id))
}

export function canTeacherEditPaper(row, me) {
  return isTeacherOwnPaper(row, me) && (row.status === 0 || row.status === 3)
}

export function canTeacherMovePaper(row, me) {
  return isTeacherOwnPaper(row, me)
}
